import { useSite } from "@/context/SiteContext";

export const TrustStrip = () => {
  const { settings } = useSite();
  const logos = settings?.trust_strip_logos?.length
    ? settings.trust_strip_logos
    : ["BRAC Bank", "City Bank", "Square Group", "DBL Group", "Pran-RFL", "Chittagong Port", "Robi", "Beximco"];
  const eyebrow = settings?.trust_strip_eyebrow || "Built for enterprises that don't get a second chance";
  const items = [...logos, ...logos];
  return (
    <section
      id="platform"
      data-testid="trust-strip"
      className="relative border-y border-neutral-200 bg-neutral-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <p className="text-center font-mono-ui text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-7">
          {eyebrow}
        </p>
        <div className="overflow-hidden">
          <div className="marquee-track flex gap-12 whitespace-nowrap will-change-transform">
            {items.map((name, i) => (
              <div
                key={i}
                className="font-display text-xl sm:text-2xl font-semibold text-neutral-400 hover:text-neutral-900 transition-colors"
              >
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
